export const PLP_PRODUCT_CLICKED = 'PLP: Product Clicked';
export const PLP_PRODUCT_ADDED_TO_CART = 'PLP: Product Added To Cart';
export const SLIDER_PRODUCT_CLICKED = 'Slider: Product Clicked';
export const PDP_PRODUCT_ADDED_TO_CART_AFTER_SEARCH = 'PDP: Product Added To Cart After Search';
export const PDP_PRODUCT_ADDED_TO_CART = 'PDP: Product Added To Cart';
export const PRODUCT_VIEWED = 'Product Viewed';
export const PDP_VIEWED = 'Product Details Page Viewed';
export const PDP_VIEWED_AFTER_SEARCH = 'Product Details Page Viewed After Search';
export const QUICK_VIEW_PRODUCT_ADDED_TO_CART = 'Quickview: Product Added To Cart';
export const QUICK_VIEW_PRODUCT_ADDED_TO_CART_AFTER_SEARCH = 'Quickview: Product Added To Cart After Search';
export const AUTOCOMPLETE_PRODUCT_CLICKED = 'Autocomplete: Product Clicked';
export const FILTER_APPLIED = 'Filter Applied';
export const BIM_PLP_FILE_DOWNLOADED = 'BIM Library: Product file downloaded';
export const BIM_PDP_FILE_DOWNLOADED = 'BIM PDP: Product file downloaded';
export const BIM_LIB_PRODUCT_ALL_FILE_DOWNLOADED = 'BIM Library: All files downloaded for a product';
export const BIM_PDP_PRODUCT_ALL_FILE_DOWNLOADED = 'BIM PDP: All files downloaded for a product';
export const BIM_LIB_DOWNLOAD_SELECTED_FILES = 'BIM Library: Files downloaded for selected Brands, Categories or Products';
export const BIM_LIB_DOWNLOAD_ALL_FILES = 'BIM Library: All Files downloaded';
export const VIDEO_PLAYED = 'Video Played';
export const CASE_STUDY_DOWNLOAD = 'Case Study: PDF downloaded';
export const CONTACT_US_ENQUIRY = 'Contact Us: Enquiry Submitted';
export const PROJECT_UPDATED = 'Project Builder: Project Details Updated';
export const PROJECT_CREATED = 'Project Builder: New Project Created';
export const PROJECT_SHARED = 'Project Builder: Project Shared';
export const PROJECT_PRODUCTS_UPDATED = 'Project Builder: Products Updated in Projects';
export const REGISTRATION = 'User signed up';
export const EXPORT_TO_EXCEL = 'Project Builder: Export to excelsheet';
export const EXPORT_TO_CSV = 'Project Builder: Export to csv';
export const SAVE_BUTTON_CLICK = 'Project Builder: Save button clicked';
export const PRINT_BUTTON_CLICK = 'Project Builder: Print button clicked';
